import { map, mergeMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
export class QuestionUtilsService {
    getFilteredOptions$(options$, search$, labelMapper) {
        return options$.pipe(mergeMap(options => search$.pipe(map(search => (search || '').toLowerCase()), map(search => options.filter(option => {
            const label = this.getValue(option, labelMapper) || '';
            return label.toLowerCase().includes(search);
        })))));
    }
    getValue(option, mapper) {
        if (!option || !mapper) {
            return null;
        }
        switch (typeof mapper) {
            case 'string':
                return option[mapper];
            case 'function':
                return mapper(option);
            default:
                return `${option}`;
        }
    }
}
QuestionUtilsService.ngInjectableDef = i0.defineInjectable({ factory: function QuestionUtilsService_Factory() { return new QuestionUtilsService(); }, token: QuestionUtilsService, providedIn: "root" });
